import React from "react"
import PropTypes from "prop-types"
import FontAwesome from "react-fontawesome"
import "./SearchBox.scss"

const SearchBox = props => (
  <div className="SearchBox">
    <FontAwesome className="search-icon" name={"search"} />

    <label className="hidden" for="search">
      Search
    </label>
    <input
      id="search"
      type="text"
      placeholder="Search"
      value={props.query}
      onChange={e => props.onChange(e.target.value)}
    />
  </div>
)

SearchBox.propTypes = {
  query: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
}

SearchBox.defaultProps = {
  query: "",
}

export default SearchBox
